export default __webpack_public_path__ + "static/firefox-15a1d97a78409f7293e522e1587b382e.svg";